import { render } from "./EditeProductCategories.vue?vue&type=template&id=024b33b5&scoped=true"
import script from "./EditeProductCategories.vue?vue&type=script&lang=js"
export * from "./EditeProductCategories.vue?vue&type=script&lang=js"

import "./EditeProductCategories.vue?vue&type=style&index=0&id=024b33b5&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024b33b5"]])

export default __exports__